import { connect } from 'react-redux';
import { switchStream, init, streamLoadMore } from './actionCreators';
import { EmoteStreamType } from './types';
import { getActiveStream, getIsLoading, getStream, getIsLoadingStream, } from './selectors';
var mapStateToProps = function (state) { return ({
    activeStream: getActiveStream(state) || EmoteStreamType.OFFICIAL,
    officialEmotes: getStream(state, EmoteStreamType.OFFICIAL),
    communityEmotes: getStream(state, EmoteStreamType.COMMUNITY),
    searchEmotes: getStream(state, EmoteStreamType.SEARCH),
    userEmotes: getStream(state, EmoteStreamType.USER),
    isLoadingStream: getIsLoadingStream(state),
    isLoading: getIsLoading(state),
}); };
var mapDispatchToProps = {
    onInitialize: init,
    onSwitchStream: switchStream,
    onLoadMore: streamLoadMore,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=EmoteSelector.container.js.map